module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reset-form"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.ruleForm.email = $$v
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("Reset password")]), _vm._v(" "), _c('router-link', {
    staticClass: "alt-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Back to Login")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dbc59d60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reset.vue
// module id = 347
// module chunks = 2